import React, { useEffect, useState } from 'react';
import Card from '../../components/ui/Card';
import Btn from '../../components/ui/Btn';
import Badge from '../../components/ui/Badge';
import Modal from '../../components/ui/Modal';
import { Input, Select } from '../../components/ui/Input';
import EmpresasModal from './EmpresasModal';
import { tenantsApi, empresasApi } from '../../api/admin';
import { COLORS } from '../../theme';

const REGIMES = [
  { value: 'simples_nacional', label: 'Simples Nacional' },
  { value: 'lucro_presumido', label: 'Lucro Presumido' },
  { value: 'lucro_real', label: 'Lucro Real' }
];

const FORM_VAZIO = {
  nome: '',
  empresa: { nome: '', razao_social: '', cnpj: '', ie: '', uf: '', municipio: '', regime_tributario: 'simples_nacional' }
};

export default function ClientesList() {
  const [clientes, setClientes] = useState([]);
  const [modalAberto, setModalAberto] = useState(false);
  const [clienteEmpresas, setClienteEmpresas] = useState(null);
  const [clienteExcluir, setClienteExcluir] = useState(null);
  const [clienteEditar, setClienteEditar] = useState(null);
  const [form, setForm] = useState(FORM_VAZIO);
  const [salvando, setSalvando] = useState(false);

  const carregar = () => tenantsApi.listar().then(setClientes).catch(() => {});
  useEffect(() => { carregar(); }, []);

  const onChange = (campo, valor) => setForm(f => ({ ...f, [campo]: valor }));
  const onChangeEmpresa = (campo, valor) => setForm(f => ({ ...f, empresa: { ...f.empresa, [campo]: valor } }));

  const salvar = async (e) => {
    e.preventDefault();
    setSalvando(true);
    try {
      await tenantsApi.criar(form);
      setModalAberto(false);
      setForm(FORM_VAZIO);
      carregar();
    } finally {
      setSalvando(false);
    }
  };

  const alternarAtivo = async (cliente) => {
    const acao = cliente.ativo ? 'desativar' : 'reativar';
    if (!window.confirm(`Tem certeza que quer ${acao} o cliente "${cliente.nome}"?${cliente.ativo ? ' Os usuários dele não vão mais conseguir logar.' : ''}`)) return;
    await tenantsApi.atualizar(cliente.id, { ativo: cliente.ativo ? 0 : 1 });
    carregar();
  };

  return (
    <div>
      <Card style={{ padding: 0, overflow: 'hidden' }}>
        <div style={{ padding: 14, borderBottom: `1px solid ${COLORS.border}`, display: 'flex', justifyContent: 'flex-end' }}>
          <Btn onClick={() => setModalAberto(true)}>+ Novo Cliente</Btn>
        </div>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
          <thead>
            <tr style={{ textAlign: 'left', background: COLORS.bg }}>
              <th style={{ padding: 10 }}>Grupo</th>
              <th style={{ padding: 10 }}>Status</th>
              <th style={{ padding: 10 }}></th>
            </tr>
          </thead>
          <tbody>
            {clientes.map(c => (
              <tr key={c.id} style={{ borderTop: `1px solid ${COLORS.border}` }}>
                <td style={{ padding: 10 }}>{c.nome}</td>
                <td style={{ padding: 10 }}>{c.ativo ? <Badge tom="sucesso">Ativo</Badge> : <Badge tom="perigo">Inativo</Badge>}</td>
                <td style={{ padding: 10, display: 'flex', gap: 8 }}>
                  <Btn tamanho="sm" variante="ghost" onClick={() => setClienteEditar(c)}>Editar</Btn>
                  <Btn tamanho="sm" variante="ghost" onClick={() => setClienteEmpresas(c)}>Empresas (CNPJs)</Btn>
                  <Btn tamanho="sm" variante={c.ativo ? 'danger' : 'secondary'} onClick={() => alternarAtivo(c)}>
                    {c.ativo ? 'Desativar' : 'Reativar'}
                  </Btn>
                  <Btn tamanho="sm" variante="danger" onClick={() => setClienteExcluir(c)}>Excluir</Btn>
                </td>
              </tr>
            ))}
            {clientes.length === 0 && (
              <tr><td colSpan={3} style={{ padding: 20, textAlign: 'center', color: COLORS.textMid }}>Nenhum cliente cadastrado ainda.</td></tr>
            )}
          </tbody>
        </table>
      </Card>

      {modalAberto && (
        <Modal
          titulo="Novo Cliente"
          onFechar={() => setModalAberto(false)}
          largura={560}
          rodape={
            <>
              <Btn variante="ghost" onClick={() => setModalAberto(false)}>Cancelar</Btn>
              <Btn onClick={salvar} disabled={salvando}>{salvando ? 'Salvando...' : 'Salvar'}</Btn>
            </>
          }
        >
          <form onSubmit={salvar} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <Input label="Nome do Grupo" value={form.nome} onChange={e => onChange('nome', e.target.value)} required
              placeholder="Ex: Sma / Prodisk / Nacional" />
            <p style={{ fontSize: 12, color: COLORS.textMid, margin: '4px 0 0' }}>
              Dados da primeira empresa (CNPJ) do grupo — mais podem ser adicionados depois:
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <Input label="Nome Fantasia" value={form.empresa.nome} onChange={e => onChangeEmpresa('nome', e.target.value)} required />
              <Input label="Razão Social" value={form.empresa.razao_social} onChange={e => onChangeEmpresa('razao_social', e.target.value)} />
              <Input label="CNPJ" value={form.empresa.cnpj} onChange={e => onChangeEmpresa('cnpj', e.target.value)} />
              <Input label="Inscrição Estadual" value={form.empresa.ie} onChange={e => onChangeEmpresa('ie', e.target.value)} />
              <Input label="UF" value={form.empresa.uf} onChange={e => onChangeEmpresa('uf', e.target.value)} maxLength={2} />
              <Input label="Município" value={form.empresa.municipio} onChange={e => onChangeEmpresa('municipio', e.target.value)} />
              <Select label="Regime Tributário" options={REGIMES} value={form.empresa.regime_tributario} onChange={e => onChangeEmpresa('regime_tributario', e.target.value)} />
            </div>
          </form>
        </Modal>
      )}

      {clienteEmpresas && <EmpresasModal tenant={clienteEmpresas} onFechar={() => setClienteEmpresas(null)} />}

      {clienteExcluir && (
        <ExcluirClienteModal
          cliente={clienteExcluir}
          onFechar={() => setClienteExcluir(null)}
          onExcluido={() => { setClienteExcluir(null); carregar(); }}
        />
      )}

      {clienteEditar && (
        <EditarClienteModal
          cliente={clienteEditar}
          onFechar={() => setClienteEditar(null)}
          onSalvo={() => { setClienteEditar(null); carregar(); }}
        />
      )}
    </div>
  );
}

function EditarClienteModal({ cliente, onFechar, onSalvo }) {
  const [form, setForm] = useState({ nome: cliente.nome });
  const [empresaPadrao, setEmpresaPadrao] = useState(null);
  const [outrasEmpresas, setOutrasEmpresas] = useState(0);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    empresasApi.listar(cliente.id).then(lista => {
      const padrao = lista.find(e => e.padrao) || lista[0] || null;
      setEmpresaPadrao(padrao ? {
        id: padrao.id, nome: padrao.nome || '', razao_social: padrao.razao_social || '',
        cnpj: padrao.cnpj || '', ie: padrao.ie || '', uf: padrao.uf || '',
        municipio: padrao.municipio || '', regime_tributario: padrao.regime_tributario
      } : null);
      setOutrasEmpresas(lista.length - (padrao ? 1 : 0));
    }).finally(() => setCarregando(false));
  }, [cliente.id]);

  const onChange = (campo, valor) => setForm(f => ({ ...f, [campo]: valor }));
  const onChangeEmpresa = (campo, valor) => setEmpresaPadrao(f => ({ ...f, [campo]: valor }));

  const salvar = async (e) => {
    e.preventDefault();
    setSalvando(true);
    setErro('');
    try {
      await tenantsApi.atualizar(cliente.id, form);
      if (empresaPadrao) {
        const { id, ...dadosEmpresa } = empresaPadrao;
        await empresasApi.atualizar(id, dadosEmpresa);
      }
      onSalvo();
    } catch (err) {
      setErro(err.message);
    } finally {
      setSalvando(false);
    }
  };

  return (
    <Modal
      titulo={`Editar "${cliente.nome}"`}
      onFechar={onFechar}
      largura={560}
      rodape={
        <>
          <Btn variante="ghost" onClick={onFechar}>Cancelar</Btn>
          <Btn onClick={salvar} disabled={salvando || carregando}>{salvando ? 'Salvando...' : 'Salvar'}</Btn>
        </>
      }
    >
      {carregando ? <p>Carregando...</p> : (
        <form onSubmit={salvar} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
          <Input label="Nome do Grupo" value={form.nome} onChange={e => onChange('nome', e.target.value)} required autoFocus />

          {empresaPadrao && (
            <>
              <div style={{ borderTop: `1px solid ${COLORS.border}`, paddingTop: 14 }}>
                <strong style={{ fontSize: 13 }}>Empresa padrão (CNPJ)</strong>
                {outrasEmpresas > 0 && (
                  <p style={{ fontSize: 11, color: COLORS.textLight, margin: '4px 0 0' }}>
                    Este grupo tem mais {outrasEmpresas} empresa(s) — para editá-las, use "Empresas (CNPJs)".
                  </p>
                )}
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <Input label="Nome Fantasia" value={empresaPadrao.nome} onChange={e => onChangeEmpresa('nome', e.target.value)} required />
                <Input label="Razão Social" value={empresaPadrao.razao_social} onChange={e => onChangeEmpresa('razao_social', e.target.value)} />
                <Input label="CNPJ" value={empresaPadrao.cnpj} onChange={e => onChangeEmpresa('cnpj', e.target.value)} />
                <Input label="Inscrição Estadual" value={empresaPadrao.ie} onChange={e => onChangeEmpresa('ie', e.target.value)} />
                <Input label="UF" value={empresaPadrao.uf} onChange={e => onChangeEmpresa('uf', e.target.value)} maxLength={2} />
                <Input label="Município" value={empresaPadrao.municipio} onChange={e => onChangeEmpresa('municipio', e.target.value)} />
                <Select label="Regime Tributário" options={REGIMES} value={empresaPadrao.regime_tributario} onChange={e => onChangeEmpresa('regime_tributario', e.target.value)} />
              </div>
            </>
          )}

          {erro && <p style={{ color: COLORS.danger, fontSize: 13, margin: 0 }}>{erro}</p>}
        </form>
      )}
    </Modal>
  );
}

function ExcluirClienteModal({ cliente, onFechar, onExcluido }) {
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [excluindo, setExcluindo] = useState(false);

  const confirmar = async (e) => {
    e.preventDefault();
    setExcluindo(true);
    setErro('');
    try {
      await tenantsApi.excluir(cliente.id, senha);
      onExcluido();
    } catch (err) {
      setErro(err.message);
    } finally {
      setExcluindo(false);
    }
  };

  return (
    <Modal
      titulo={`Excluir "${cliente.nome}"`}
      onFechar={onFechar}
      largura={440}
      rodape={
        <>
          <Btn variante="ghost" onClick={onFechar}>Cancelar</Btn>
          <Btn variante="danger" onClick={confirmar} disabled={excluindo || !senha}>{excluindo ? 'Excluindo...' : 'Excluir definitivamente'}</Btn>
        </>
      }
    >
      <form onSubmit={confirmar} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <p style={{ fontSize: 13, color: COLORS.danger, margin: 0, fontWeight: 600 }}>
          Isso apaga o cliente e TUDO que pertence a ele — empresas (CNPJs), usuários, produtos, estoque e movimentações. Não tem como desfazer.
        </p>
        <Input label="Digite sua senha de admin para confirmar" type="password" value={senha} onChange={e => setSenha(e.target.value)} required autoFocus />
        {erro && <p style={{ color: COLORS.danger, fontSize: 13, margin: 0 }}>{erro}</p>}
      </form>
    </Modal>
  );
}
